import { useState, useEffect } from "react";
import { cloneDeep } from "lodash";

/**
 * @desc Manage convention state.
 */
export const useConventionState = (convention = {}) => {
  const [products, setProducts] = useState(convention?.products || []);

  /**
   * @desc On convention change, update state.
   */
  useEffect(() => {
    setProducts(cloneDeep(convention?.products));
  }, [convention]);

  // HOOK ---------------------------------------------------------------------

  return {
    products,
    setProducts,
  };
};
